<template>


  <div class="bg-white person-list">
    <!-- <div
      style="font-size: 18px;font-weight: 500; border-bottom: 1px solid #CCCCCC; padding-bottom: 16px;margin-bottom: 16px;">
      {{ L('热门专家') }}
    </div> -->

    <!-- <div style="display: flex;margin-bottom: 16px;">
              <input type="text" v-model="searchValue" :placeholder="L('请输入专家姓名')" style="flex: 1; border: 1px solid #ccc; margin-right: 8px;padding: 8px;" />
              <button @click="search" style="background-color: #DC000C; border-color: #DC000C; color: #fff; padding: 0 16px;">{{ L('确定') }}</button>
            </div> -->

    <div>
      <div v-for="item in newsList" :key="item.newsId" class="expert-item" @click="toDetails(item)">
        <img v-if="item.photo" class="expert-avatar" :src="item.photo" alt="expert photo" />
        <img v-else src="@/assets/images/default-avatar.png" class="expert-avatar">

        <div>
          <div class="title" style="font-weight: bold;margin-bottom: 4px;">{{ L(item.name) }}</div>
          <!-- <div style="font-size: 0.8em;margin-bottom: 4px;     color: rgba(0, 0, 0, .7);">
            <span>人气：</span>
            <span style="color: #DC000C;"> {{ item.tips }}</span>
          </div>
          <div style="font-size: 0.8em;margin-bottom: 4px;     color: rgba(0, 0, 0, .7);">
            <span>文章：</span>
            <span style="color: #DC000C;">{{ item.likes + 1 }}</span>
          </div> -->
          <div class="brief" v-html="item.intro">
          </div>
        </div>
      </div>
    </div>

    <!-- <More>更多专家</More> -->
  </div>


</template>

<script>
import More from "./more.vue";
// import { searchExpert} from ''
export default {
  components: {
    More
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchValue: '',
      newsList: []
    }
  },
  watch: {
    list() {
      this.newsList = this.list.map((item) => {
        item.photo = !/^http/.test(item.photo)
          ? this.$imgUrl + item.photo
          : item.photo;
        return item;
      });
    }
  },
  methods: {
    search() {
      if (this.searchValue) {
        // searchExpert(this.searchValue).then(res => {
        //   this.newsList = res.data;
        // })
      }
    },
    toDetails(item, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        // if (item.price > 0) {
        this.$router.push({
          path: `/expert-details/${item.id}`,
        });
        // } else {
        //   this.$router.push({
        //     path: `/article-details/${item.newsId}`,
        //   });
        // }
      }
    },
    toArticle(typeId) {
      this.$router.push({
        path: `/article?typeId=${typeId}`,
      });
    },
  }
}
</script>

<style scoped>
.person-list {
  flex: 1;
  padding: 16px;
  box-sizing: border-box;
}

.expert-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 20px;

  .expert-avatar {
    width: 84px;
    height: 84px;
    object-fit: cover;
    margin-right: 12px;
    border-radius: 50%;
  }

  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #2C2C2E;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    margin-bottom: 4px;
  }

  .brief {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #AEAEB2;
    line-height: 19px;
    text-align: left;
    font-style: normal;
  }
}

@media screen and (max-width: 768px) {
  .person-list {
    padding: 0;
  }

  .expert-item {

    .expert-avatar {
      width: 68px;
      height: 68px;
    }

    .title {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: left;
      font-style: normal;
    }

    .brief {
      font-family: MicrosoftYaHei;
      font-size: 12px;
      color: #AEAEB2;
      line-height: 16px;
      text-align: left;
      font-style: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/expert/person.vue